import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {
    BadgeColor,
    GenericBadgeComponent,
} from '@h20-shared/generic-badge/generic-badge.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

export type BadgeCellRendererParamsTypes = {
    text: string;
    badgeColor: BadgeColor;
    plainText?: boolean;
    tooltip?: string;
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-badge-cell-renderer',
    templateUrl: './badge-cell-renderer.component.html',
    styleUrls: ['./badge-cell-renderer.component.scss'],
    imports: [GenericBadgeComponent, TranslateModule, NgbTooltip],
})
export class BadgeCellRendererComponent implements ICellRendererAngularComp {
    protected readonly badgeParams: WritableSignal<BadgeCellRendererParamsTypes | undefined> =
        signal(undefined);

    agInit(
        params: ICellRendererParams & {
            badgeParams: BadgeCellRendererParamsTypes;
        }
    ): void {
        this.badgeParams.set(params.badgeParams);
    }

    refresh(
        params: ICellRendererParams & {
            badgeParams: BadgeCellRendererParamsTypes;
        }
    ) {
        this.agInit(params);
        return true;
    }
}
